import { useFormContext } from 'react-hook-form';
import { useQuery } from 'react-query';
import {
  DIGITAL_FAIR_VALUE_KEY,
  getCategories,
} from 'api/services/mediaPlanning/mediaPlanning';
import { SelectChangeEvent } from '@mui/material';
import { useParams } from 'react-router-dom';
import { FormSelect } from '../../../common/FormSelect/FormSelect';
import usePlanStore from '../../../../../../store/planStore';

export default function CategorySelect() {
  const { control } = useFormContext();

  const { generalInfoState, setGeneralInfoState } = usePlanStore((state) => ({
    generalInfoState: state.generalInfoState,
    setGeneralInfoState: state.setGeneralInfoState,
  }));

  const { id } = useParams();

  const { data: categoryResponse, isFetching } = useQuery(
    [
      DIGITAL_FAIR_VALUE_KEY,
      'categories',
      generalInfoState.division,
      generalInfoState.brand,
    ],
    () => getCategories(generalInfoState.division, generalInfoState.brand),
    {
      enabled: !!generalInfoState.division && !!generalInfoState.brand,
    }
  );

  return (
    <FormSelect
      name="category"
      control={control}
      value={generalInfoState.category}
      label="Category"
      options={categoryResponse?.data.categories || []}
      isDisabled={
        isFetching ||
        !generalInfoState.division ||
        !generalInfoState.brand ||
        !!id
      }
      isLoading={isFetching}
      onChange={(event: SelectChangeEvent<unknown>) => {
        setGeneralInfoState({ category: event.target.value as string });
      }}
    />
  );
}
